import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scroll(0, 0); // scroll to top on route change
  }, [pathname]);

  return null;
}

export default ScrollTop;
